import { variablePatterns } from '../constants/variable-names';
import { SECONDARY_BUTTON_PRESETS_COUNT } from '../constants/button-preset-section-ids';

const expandSecondaryButtonVariables = (variableName) =>
  [...Array(SECONDARY_BUTTON_PRESETS_COUNT)].map((_, number) =>
    variableName.replace(
      variablePatterns.SECONDARY_BUTTON_VARIABLE,
      `secondary_button_${number + 1}`
    )
  );

export default expandSecondaryButtonVariables;
